export default {
  solicitudes: () => import("./lib/solicitudes-icon.svg"),
  polizas: () => import("./lib/polizas-icon.svg"),
  perfil: () => import("./lib/perfil-icon.svg"),
  calendarBlack: () => import("./lib/calendar-icon--black.svg"),
};
